import React, { useEffect, useState } from 'react';
import EditLargeCardFormik from '../../main/edit-large-card-formik';
import ProfileSettlementDetailsForm, {
    SettlementDetailsValues,
    validateSettlementDetails,
} from './profile-settlement-details-form';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import {
    LoadSettlementBillingDetails,
    SettlementBillingDetails,
    UpdateSettlementBillingDetails,
} from '../../../store/userDetailsSlice';
import { RequestStatus } from '../../../store/network/managedRequest';
import LargeCard from '../../main/large-card';
import useTranslate from '../../useTranslate';
import Spinner from '../../util/spinner';
import { PbRequest } from '../../../store/pbRequest';
import { PbGenericRequest } from '../../../store/pbRequestSlice';

interface Props {
    settlementBillingDetailsRequest: PbGenericRequest;
    settlementBillingDetailsData: SettlementBillingDetails | undefined;
    updateRequestStatus: RequestStatus;
    footnote?: string;
    disabled?: boolean;

    UpdateSettlementBillingDetails: (data: SettlementBillingDetails) => void;
    LoadSettlementBillingDetails: () => void;
    internalManager: boolean;
}

function ProfileSettlementDetailsCard(props: Readonly<Props>) {
    const strings = useTranslate('ProfileBillingDataForm');
    const [reinit, setReinit] = useState(false);
    useEffect(() => {
        if (
            !reinit &&
            props.settlementBillingDetailsRequest.status ===
                RequestStatus.PENDING
        ) {
            setReinit(true);
        } else if (
            reinit &&
            props.settlementBillingDetailsRequest.status ===
                RequestStatus.SUCCESS
        ) {
            setReinit(false);
        }
    }, [props.settlementBillingDetailsRequest.status, reinit]);

    const dataReady =
        props.settlementBillingDetailsRequest.status ===
            RequestStatus.SUCCESS && !!props.settlementBillingDetailsData;

    if (
        props.settlementBillingDetailsRequest.status === RequestStatus.FAILURE
    ) {
        return (
            <LargeCard title={strings.title} type={'card-edit'}>
                {strings.errorLoading}
            </LargeCard>
        );
    }
    if (!dataReady) {
        return (
            <LargeCard title={strings.title} type={'card-edit'}>
                <Spinner />
            </LargeCard>
        );
    }

    const initialValues: SettlementDetailsValues = {
        useSettlement: props.settlementBillingDetailsData?.bank_data_available,
        holder: props.settlementBillingDetailsData?.account_holder_name,
        iban: props.settlementBillingDetailsData?.iban,
        bic: props.settlementBillingDetailsData?.bic,
        useEmail: props.settlementBillingDetailsData?.auto_receive_credit_note,
        emailAddress:
            props.settlementBillingDetailsData?.receive_credit_note_email,
        creditNotesEnabled:
            props.settlementBillingDetailsData?.credit_notes_enabled,
    };
    return (
        <EditLargeCardFormik
            title={strings.title}
            description={strings.description}
            handleSubmit={handleSubmit}
            initialValues={initialValues}
            validate={validateSettlementDetails}
            enableReinitialize={reinit}
            error={props.updateRequestStatus === RequestStatus.FAILURE}
            footnote={props.footnote}
            disabled={props.disabled}
        >
            {(formProps) => (
                <ProfileSettlementDetailsForm
                    disabled={!formProps.active}
                    internalManager={props.internalManager}
                />
            )}
        </EditLargeCardFormik>
    );

    function handleSubmit(values: SettlementDetailsValues) {
        props.UpdateSettlementBillingDetails({
            bank_data_available: values.useSettlement,
            account_holder_name: values.holder,
            iban: values.iban,
            bic: values.bic,
            auto_receive_credit_note: values.useEmail,
            receive_credit_note_email: values.emailAddress,
            credit_notes_enabled: values.creditNotesEnabled,
        });
    }
}

export default connect(
    (state: RootState) => ({
        settlementBillingDetailsRequest:
            state.pbRequest[PbRequest.FETCH_SETTLEMENT_BILLING_DETAILS],
        settlementBillingDetailsData:
            state.userDetails.settlementBillingDetails,
        updateRequestStatus:
            state.pbRequest[PbRequest.UPDATE_SETTLEMENT_BILLING_DETAILS].status,
    }),
    { UpdateSettlementBillingDetails, LoadSettlementBillingDetails }
)(ProfileSettlementDetailsCard);
